// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"344":"736ce7d2","562":"35db51e6"}[chunkId] + ".chunk.css";
};